module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8075fd8604b9a5ba15f5ff83abf61357.png";